import React from 'react';
import { Segment } from 'semantic-ui-react';


const About = () =>{
return (
    <div>
        <div className="segment-container">
            <Segment id='odd-segment-1' color='olive'><p className="standard-text"><strong>Hygiene Systems</strong> is a new company that is specialed on <strong>Hygenic toilet seats</strong> and toilet seat
            covers. We are a new company founded by three people with different backgrounds but all of
            us have been working in the industries (restaurants, universities, gas stations) in which
            sanitation of public restrooms was mandatory, so we know what it takes to keep a bathroom
            clean.</p></Segment>

            <Segment  id='even-segment-1' color="green">
            <p className="standard-text">Our products are a perfect fit for hospitals, gas stations, restaurants, office buildings, schools,
            movie theaters, airports.</p>
            </Segment>

            <Segment id='odd-segment-2' color='teal'>
            <p className="standard-text">Touchless Hygiene Systems work in the simplest wave: You wave your hand over a wall
            mounted sensor (or a button is pressed on the seat) and a new, fresh, hygienic toilet seat cover
            is there for you for your peace of mind.</p>
            </Segment>

            <Segment id='even-segment-2' color="blue">
            <p className="standard-text">Touchless Hygiene Systems prevent spreading of germs on hand and the body. Therefore it will
            save public health from extra spending and will help the healthcare people to work on other
            patients who won’t have to suffer longer lines.</p>
            </Segment>
 
        </div>


        <div className="founder-container">
            <div className="ui link cards">
                <div className="card">
                    <div className="image">
                    <img className="founder-image" src={require('./person1.png')}/>
                    </div>
                    <div className="content">
                    <div className="header">Osman Yildirim</div>
                    <div className="meta">
                        <a>Founder</a>
                    </div>
                    <div className="description">
                        Osman is the founder of Hygiene Systems
                    </div>
                    </div>
                </div>
                <div className="card">
                    <div className="image">
                        <img className="founder-image" src={require('./person1.png')}/>
                    </div>
                    <div className="content">
                    <div className="header">Inan Temelkuran</div>
                    <div className="meta">
                        <span className="date">Co-Founder</span>
                    </div>
                    <div className="description">
                        Inan is one of the Co-Founders of Hygiene Systems
                    </div>
                    </div>
                </div>
                <div className="card">
                    <div className="image">
                        <img className="founder-image" src={require('./person1.png')}/>
                    </div>
                    <div className="content">
                    <div className="header">Selcuk Koyuncu</div>
                    <div className="meta">
                        <a>Co-Founder</a>
                    </div>
                    <div className="description">
                        Selcuk is one of the Co-Founders of Hygiene Systems.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
)
}

export default About;